const DEFAULT_MAX_LENGTH = 100
const SUFFIX = '...'

const MaxLenFilter = {
  name: 'maxLen',
  fn: (value: {}, maxLength: number) : string => {
    if (!value) return ''

    const maxLengthThrunk = maxLength || DEFAULT_MAX_LENGTH
    const strvalue = value.toString()
    if (strvalue.length <= maxLengthThrunk) {
      return strvalue
    }

    return strvalue.substring(0, maxLengthThrunk - SUFFIX.length) + SUFFIX
  }
}

export default MaxLenFilter
